import { useContext } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Link, useLocation } from 'react-router';
import { store } from 'components/Store';
import getAppSite from 'utils/getAppSite';
import parliamentarianUsers from 'components/Dashboard/SidebarElements/parliamentarianUsers';
import { copyTextToClipboard } from 'components/Dashboard/helpers/copyFunctionality';
import {
  ContactHolMemberInfoIcon,
  contactHolMemberCondition,
} from 'components/Dashboard/Influence/CrmContacts/CrmContactsTable/CrmContactItem/CrmContactItem';
import StakeholderEmailAddresses from 'components/Dashboard/StakeHolders/StakeholderPage/ui/StakeholderEmailAddresses';

const InfoField = ({ label, children }) => (
  <>
    <h4 className='category-subtitle member-info-subtitle'>{label}</h4>
    <p className='mb-0 member-data'>{children}</p>
  </>
);

const CopyEmailButton = ({ email }) => (
  <button
    className='general-button member-email-button'
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      copyTextToClipboard(email, 'Email address has been copied');
    }}
    data-tooltip-content='Copy email address'
    data-tooltip-id='general-tooltip'
  >
    <span className='icon-copy-thin paragraph-p4 light-60-text font-weight-normal d-inline-block' />
  </button>
);

const BasicInformation = (props) => {
  const globalState = useContext(store);
  const { state } = globalState;
  const { activePlan } = state;
  const { enableStakeholders, code } = activePlan;
  const { StakeholderInformation, crmEmail, onSaveEmail } = props;
  const { party, constituency, email, website, ministerialEmailAddress, positionCategories } = StakeholderInformation;

  const location = useLocation();
  const { isAuthenticated } = useAuth0();

  return (
    <>
      {constituency !== null && (
        <InfoField label={getAppSite() === 'usa' ? 'District' : 'Constituency'}>{constituency}</InfoField>
      )}
      {party !== null && <InfoField label='Political party'>{party}</InfoField>}
      {website !== null && (
        <InfoField label='Personal website'>
          <a className='external-url' href={website} rel='noopener noreferrer' target='_blank'>
            {website}
            <button
              className='general-button member-email-button external-url-button'
              data-tooltip-content='Open website'
              data-tooltip-id='general-tooltip'
            >
              <span className='icon-external-link paragraph-p5 light-60-text font-weight-normal ' />
            </button>
          </a>
        </InfoField>
      )}
      {(email !== null || crmEmail) && (
        <>
          {crmEmail ? (
            <StakeholderEmailAddresses
              crmEmail={crmEmail}
              ministerialEmailAddress={ministerialEmailAddress}
              positionCategories={positionCategories}
              onSaveEmail={onSaveEmail}
            />
          ) : (
            <>
              <h4 className='category-subtitle member-info-subtitle'>Email</h4>
              {isAuthenticated && (
                <>
                  {(parliamentarianUsers(code) || enableStakeholders) && (
                    <p className='mb-0 member-data'>
                      <a
                        className='external-url mail-url'
                        href={`mailto:${email}`}
                        id={'stakeholder-email-external-link'}
                      >
                        {email}
                      </a>
                      {contactHolMemberCondition(email) && (
                        <ContactHolMemberInfoIcon
                          className='paragraph-p3 ml-2 d-inline-block'
                          style={{ color: 'rgba(0, 18, 43, 0.55)', transform: 'translateY(1px)' }}
                        />
                      )}
                      <CopyEmailButton email={email} />
                    </p>
                  )}
                  {!enableStakeholders && (
                    <Link className='simple-link-button' to={`/pricing?returnUrl=${location.pathname}`}>
                      Upgrade to Mogul to reveal contact info
                    </Link>
                  )}
                </>
              )}
              {!isAuthenticated && (
                <button
                  className='general-button simple-link-button'
                  onClick={() => {
                    window.location.assign(`/register?reg_source=stakeholder_page_see_email`);
                  }}
                >
                  Sign up to reveal contact info
                </button>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export { InfoField, CopyEmailButton };
export default BasicInformation;
